/**
 * P_USER_WELCOME_DISPATCH_3.1 — Audit Log anchor URL builder.
 *
 * Pure function — no DOM, no React. Lives in lib/ so it can be unit
 * tested with a dependency-free Node runner (see
 * `lib/__tests__/audit_anchor.test.mjs`).
 *
 * Contract:
 *   • returns null when `details` is null / undefined.
 *   • returns null when `details.dispatch_id` is missing.
 *   • returns null when `details.category` is not one of the two
 *     supported communications categories.
 *   • returns null when category is `campaign_dispatch` but
 *     `details.campaign_id` is missing (the campaign drawer needs
 *     both ids).
 *   • returns the deep-link URL string otherwise.
 *
 * Output URLs:
 *   welcome_dispatch  → /admin/user-welcome-dispatch?dispatch_id=X
 *   campaign_dispatch → /admin/user-welcome-dispatch?campaign_id=X&dispatch_id=Y
 */
export function buildDispatchAnchorUrl(details) {
    const det = details || {};
    if (!det.dispatch_id) return null;
    if (det.category === 'campaign_dispatch') {
        if (!det.campaign_id) return null;
        const p = new URLSearchParams({
            campaign_id: det.campaign_id,
            dispatch_id: det.dispatch_id,
        });
        return `/admin/user-welcome-dispatch?${p.toString()}`;
    }
    if (det.category === 'welcome_dispatch') {
        const p = new URLSearchParams({ dispatch_id: det.dispatch_id });
        return `/admin/user-welcome-dispatch?${p.toString()}`;
    }
    return null;
}
